import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = localStorage.getItem("pblux_admin_token");
  return axios.create({
    baseURL: API,
    headers: token ? { "X-Admin-Token": token } : {},
  });
};

export const PHP = (n) =>
  new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP", maximumFractionDigits: 0 }).format(n || 0);

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_palawan-wheels/artifacts/cym6mjoh_IMG_0227.png";
